<script lang="ts">
    import { widgetState } from "../store/widget.store";
    export let textAlign = 'text-center'
    export let showSubtitle: Boolean = true;
    export let titleColor = '000000';
</script>
<div class="hero-banner {textAlign}">
    <h1 class="font-semibold text-xl py-1" style="color: #{titleColor}">{$widgetState.config.title}</h1>
    {#if showSubtitle}
        <h2 class="text-sm">{@html $widgetState.config.sub_title}</h2>
    {/if}
</div>

<style lang="scss">
    .hero-banner {
        grid-area: hero-banner;
    }
</style>